<template>
    <b-modal size="md" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialog" :hide-footer="true" :hide-header="true" title="">
        <form>
            <div class="row">
                <div class="form-group col-md-12 text-center">

                    <div class="swal2-icon swal2-error swal2-animate-error-icon" style="display: flex;">
                        <span class="swal2-x-mark">
                            <span class="swal2-x-mark-line-left"></span>
                            <span class="swal2-x-mark-line-right"></span>
                        </span>
                    </div>

                    <div class="p-3">
                        <h3>Você ainda está aí?</h3>
                        <p>Sua sessão será encerrada por inatividade.</p>
                        <p>Clique em qualquer lugar da tela para interromper o contador.</p>
                        <p style="color:darkred">{{ second }}</p>
                    </div>

                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
    import Auth from '@/common/auth'
    import Cache from '@/common/cache'

    export default {
        data() {
            return {
                dialog: false,
                time: 0
            }
        },
        computed: {
            second() {
                let min = Math.floor((this.time / 1000 / 60) << 0);
                let sec = Math.floor((this.time / 1000) % 60).toString().padStart(2, '0');
                return (min + ':' + sec);
            },
        },
        async mounted() {
            this.time = Cache.get(Auth.encerraSessao)
            this.dialog = true;
        },
         created() {
            
            let timerId = setInterval(() => {
                this.time -= 1000;
                
                if (!this.$parent.$root.isAppIdle) {
                    clearInterval(timerId);
                }
                if (this.time < 1) {
                    clearInterval(timerId);
                    Auth.logout();
                }
            }, 1000);
        }
    };
</script>